import React from 'react';
import BaseTile from 'commonComponents/tiles/BaseTile/BaseTile';
import SectionWithBoxes from 'commonComponents/sections/SectionWithBoxes/SectionWithBoxes';

const Questions = ({ headers, tiles, button }) => {
  const questionsProps = {
    headers,
    boxes: tiles,
    boxRender: (box, number) => (
      <BaseTile
        { ...box }
        key={ number }
        additionalClass="simple"
      />
    ),
    button
  };

  return (
    <SectionWithBoxes
      { ...questionsProps }
      anchor='questions'
    />
  );
};

export default Questions;
